import commonJsModule from "html-inline-css-webpack-plugin"

export default commonJsModule.default